export const STAFF_ROLES = [
  { code: 'primary', label: 'Первичник', field: 'primary_employee_ids' },
  { code: 'lead',    label: 'Ведущий',   field: 'lead_employee_ids' },
  { code: 'bank',    label: 'Банк',      field: 'bank_employee_ids' },
];
export const ROLE_LABELS = Object.fromEntries(STAFF_ROLES.map((r) => [r.code, r.label]));
